
import BlockType8 from '../1-10/BlockType8.vue';
import { HeadlineTitle, HeadlineImage, HeadlineAuthor, HeadlineLabels } from '../../fragments';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import BaseBlock from '@headlines/utils/BaseBlock';
import { CustomerData } from '@root/modules/customer/types/customer';
import BlockTypeSettings from '@headlines/types/block/100-110/blockType104';

const defaultSettings = {
  icons: true,
  author: false,
  titleComment: true,
  channel: false,
  category: true,
  bookmark: false,
  slidesPerBreakpoint: [1.85, 3.5, 4.5], // small, medium, large
  navigationPerBreakpoint: [false, true, true], // small, medium, large
  paginationPerBreakpoint: [false, false, false], // small, medium, large
  scrollbarPerBreakpoint: [true, false, false], // small, medium, large
  spaceBetweenPerBreakpoint: [24, 24, 24],
  autoplay: false,
  loop: false,
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend({
  components: {
    BlockType8,
    HeadlineImage,
    HeadlineTitle,
    HeadlineAuthor,
    HeadlineLabels,
    Swiper,
  },
  data() {
    return {
      bookmarks: [] as CustomerData[] | null,
    };
  },
  computed: {
    isAdFree() {
      return this.$store?.getters['adForm/getIsAdFree'];
    },
    swiperOptions() {
      const swiperAutoplay = this.getSettings.autoplay === true ? { delay: 2000 } : false;

      // Convert slidesPerBreakpoint to array if string passed from PBA
      if (typeof this.getSettings.slidesPerBreakpoint === 'string') {
        this.getSettings.slidesPerBreakpoint = this.getSettings.slidesPerBreakpoint.split(',').map(Number);
      }

      const swiperOptions = {
        spaceBetween: this.getSettings.spaceBetweenPerBreakpoint[0],
        initialSlide: 0,
        autoplay: swiperAutoplay,
        slidesPerView: this.getSettings.slidesPerBreakpoint[0],
        slidesPerGroup: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          enabled: this.getSettings.paginationPerBreakpoint[0],
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          enabled: this.getSettings.navigationPerBreakpoint[0],
        },
        scrollbar: {
          enabled: false,
        },
        breakpoints: {
          768: {
            freeMode: false,
            spaceBetween: this.getSettings.spaceBetweenPerBreakpoint[1],
            slidesPerView: this.getSettings.slidesPerBreakpoint[1],
            slidesPerGroup: 1,
            loop: this.getSettings.loop,
            pagination: {
              enabled: this.getSettings.paginationPerBreakpoint[1],
            },
            navigation: {
              enabled: this.getSettings.navigationPerBreakpoint[1],
            },
          },
          1230: {
            freeMode: false,
            spaceBetween: this.getSettings.spaceBetweenPerBreakpoint[2],
            slidesPerView: this.getSettings.slidesPerBreakpoint[2],
            slidesPerGroup: 1,
            loop: this.getSettings.loop,

            navigation: {
              enabled: this.getSettings.navigationPerBreakpoint[2],
            },
            pagination: {
              enabled: this.getSettings.paginationPerBreakpoint[2],
            },
          },
        },
      };

      return swiperOptions;
    },
  },
});
